import React from 'react';

const LogoSlide = ({ imgSrc, alt }) => {
  return <img className='h-[91px] mr-[52px]' loading='lazy' src={imgSrc} width={120} alt={alt} />;
};

export default LogoSlide;
